import ExternalRegisterPage from './ExternalRegisterPage';

const COLUMNS = [
  ['Product Number', 'product_number'],
  ['RMS', 'rms'],
  ['CMS', 'cms'],
  ['Product Name', 'product_name'],
  ['Active Substances', 'active_substances'],
  ['Dose Forms', 'dose_forms'],
  ['MAH', 'marketing_authorisation_holder'],
  ['Type Level', 'type_level'],
  ['ATC Code', 'atc_code'],
  ['Domain', 'domain'],
  ['Outcome', 'outcome'],
  ['Date of Outcome', 'date_of_outcome'],
  ['Updated At', 'source_updated_at'],
  ['Product Link', 'product_link'],
  ['Documents', 'documents'],
];

const DATE_COLS = new Set(['date_of_outcome', 'source_updated_at']);

const FILTER_CONFIGS = [
  { key: 'hmaSearch', label: 'Product Number', type: 'search', column: 'product_number', placeholder: 'Search by product number...' },
  { key: 'rms', label: 'RMS', column: 'rms' },
  { key: 'domain', label: 'Domain', column: 'domain' },
  { key: 'outcome', label: 'Outcome', column: 'outcome' },
  { key: 'atcCode', label: 'ATC Code', column: 'atc_code' },
  { key: 'productName', label: 'Product Name', type: 'text', column: 'product_name', placeholder: 'Search by product name...' },
  { key: 'activeSubstances', label: 'Active Substances', type: 'text', column: 'active_substances', placeholder: 'Search by active substances...' },
  { key: 'doseForms', label: 'Dose Form', column: 'dose_forms' },
  { key: 'mah', label: 'MAH', column: 'marketing_authorisation_holder' },
];

const DEFAULT_FILTERS = ['hmaSearch', 'rms', 'domain', 'outcome', 'atcCode', 'productName', 'activeSubstances', 'doseForms'];

const DETAIL_SECTIONS = [
  {
    title: 'Product Information',
    fields: [
      { key: 'product_number', label: 'Product Number' },
      { key: 'product_name', label: 'Product Name' },
      { key: 'active_substances', label: 'Active Substances', wide: true },
      { key: 'dose_forms', label: 'Dose Forms' },
      { key: 'atc_code', label: 'ATC Code' },
      { key: 'type_level', label: 'Type Level' },
    ],
  },
  {
    title: 'Regulatory',
    fields: [
      { key: 'rms', label: 'RMS (Reference Member State)' },
      { key: 'cms', label: 'CMS (Concerned Member States)', wide: true },
      { key: 'domain', label: 'Domain' },
      { key: 'outcome', label: 'Outcome' },
      { key: 'date_of_outcome', label: 'Date of Outcome' },
      { key: 'marketing_authorisation_holder', label: 'Marketing Authorisation Holder', wide: true },
    ],
  },
  {
    title: 'Reference',
    fields: [
      { key: 'source_updated_at', label: 'Source Updated At' },
      { key: 'product_link', label: 'Product Link', wide: true },
      { key: 'documents', label: 'Documents', wide: true },
    ],
  },
];

export default function HmaSupps() {
  return (
    <ExternalRegisterPage
      source="hma"
      title="HMA MRI Product Index"
      breadcrumb="HMA"
      sourceUrl="https://www.hma.eu/medicines-mri-product-index.html"
      columns={COLUMNS}
      dateColumns={DATE_COLS}
      defaultFilterKeys={DEFAULT_FILTERS}
      filterConfigs={FILTER_CONFIGS}
      prefsKey="hmaFilters"
      detailTitle="HMA MRI Product Index Record Details"
      detailSections={DETAIL_SECTIONS}
    />
  );
}
